import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Spinner, Toast, ToastContainer } from "react-bootstrap";

import { TextInput } from "../../../shared/form/FormInput";
import { Validators } from "../../../shared/utils/Validators";
import { RenderAppLogo, RenderNoAuthHeaderText } from "../../../shared/components/ConditonalComponent";

import { resetPassword } from "../../../shared/settings/apiConfig";
import { postApi } from "../../../shared/services/apiHelper";

import '../NoAuth.scss';

export default function ForgotPassword(props) {
    const [state, setState] = useState({
        formControls: {
            email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email()] },
            mobile: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.phoneNumberValid()] },
            new_password: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.minLength(8), Validators.maxLength(15)] },
            confirm_password: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.maxLength(15)] },
        },
        formValid: false,
        formLoading: false,
        message:{note:"",type:"",show:false}
    })
    const [width, setwidth] = useState()
    useEffect(() => {
        window.addEventListener('resize', () => {
            setwidth(window.innerWidth)
        });

        return () => {

        }
    }, [])
    const onInputChange = (controlName, event) => {
        let data = { ...state }
        data["formControls"][controlName] = Validators.validateFormControl(state.formControls[controlName], event.target.value)
        if (controlName === 'confirm_password' && event.target.value && event.target.value !== data["formControls"]["new_password"].value) {
            data["formControls"]["confirm_password"].valid = false;
            data["formControls"]["confirm_password"].error = 'Password does not match';
        }
        if (controlName === 'new_password' && data["formControls"]["confirm_password"].value && data["formControls"]["confirm_password"].value !== event.target.value) {
            data["formControls"]["confirm_password"].valid = false;
            data["formControls"]["confirm_password"].error = 'Password does not match';
        } else if (controlName === 'new_password' && data["formControls"]["confirm_password"].value && data["formControls"]["confirm_password"].value === event.target.value) {
            data["formControls"]["confirm_password"].valid = true;
            data["formControls"]["confirm_password"].error = '';
        }
        data["formValid"] = Validators.validateForm(data["formControls"])
        setState(data)
    }
const onResetPassword = () => {
        setState({ ...state, formLoading: true })
        const payload = {
            email: state?.formControls?.email?.value,
            mobile: state?.formControls?.mobile?.value,
            new_password: state?.formControls?.new_password?.value
        };
        postApi(resetPassword, payload, false).then(response => {
            setState({ ...state, 
                formLoading: false,
                message:{note:response?.data?.message,type:"success",show:true}
             })
             setTimeout(() => {
                setState({ ...state, 
                    formLoading: false,
                    message:{note:"",type:"",show:false}
                 })
                 props.history.push('sign-in')
             }, 3000);
           
           
        }).catch(error => {
            const detail = error?.response?.data?.detail;
            let note = 'Unable to reset password. Please try again.';
            if (typeof detail === 'string') {
                note = detail;
            } else if (Array.isArray(detail) && detail.length > 0) {
                note = detail.map(err => err?.msg).filter(Boolean).join(' ');
            }
            setState({ ...state, 
                formLoading: false,
                message:{note:note,type:"danger",show:true}
             })
             setTimeout(() => {
                setState({ ...state, 
                    formLoading: false,
                    message:{note:"",type:"",show:false}
                 })
             }, 3000);
        });
    }
    return (
        <div className="forgot-password w-100" >
            <img class="noauth-bg-img" src={`${process.env.PUBLIC_URL}/static/images/forgotscreenbg.png`} alt="bg" />
            <div className='scontainer my-2'>
                <div className='sigincontent'>
                    <div className="d-flex align-items-center justify-content-center">
                        <img className="loader-img" src={`${process.env.PUBLIC_URL}/static/images/quantsynx_logo.png`} alt="Logo" />
                    </div>
                    <div class="shadow-lg px-5 rounded">
                        <div class="w-100 d-flex justify-content-center flex-column text-gray">
                            <div className="w-100">
                                <text className="w-100 screen-head" >Forgot Password</text>
                                <div class="rounded w-100 d-flex flex-column justify-content-center align-items-center p-3 ">
                                    <div className="w-100">
                                        <TextInput type={'text'} name={'email'} label={'Email'} placeholder={'Email'}
                                            value={state.formControls.email.value} error={state.formControls.email.error} onChange={(event) => { onInputChange('email', event); }} />
                                        <TextInput type={'text'} name={'mobile'} label={'Mobile'} placeholder={'Mobile'}
                                            value={state.formControls.mobile.value} error={state.formControls.mobile.error} onChange={(event) => { onInputChange('mobile', event); }} />
                                        <TextInput type={'password'} name={'new_password'} label={'New Password'} placeholder={'New Password'}
                                            value={state.formControls.new_password.value} error={state.formControls.new_password.error} onChange={(event) => { onInputChange('new_password', event); }} />
                                        <TextInput type={'password'} name={'confirm_password'} label={'Confirm Password'} placeholder={'Confirm Password'}
                                            value={state.formControls.confirm_password.value} error={state.formControls.confirm_password.error} onChange={(event) => { onInputChange('confirm_password', event); }} />
                                        <div className=" w-100 my-4">
                                            <button type="button" className="d-flex align-items-center justify-content-center btn btn-secondary sign-btn w-100" onClick={() => { onResetPassword() }} disabled={!state.formValid}>Reset Password {state.formLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}</button>
                                            <p className="py-2">Back to <Link to="/sign-in" ><span style={{ fontWeight: "bolder", color: "hsl(215 20% 65%)" }}> Log in</span></Link>?</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className='footer-section'>
                {/* <a href="https://image.assessmax.com/assessmax/PrivacyPolicy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a> <span style={{ fontWeight: 'bold' }}>|</span>
                <a href="https://image.assessmax.com/assessmax/TermsandConditionsAcceptableandfairUsage.pdf" target="_blank" rel="noopener noreferrer"> Terms and Conditions</a> */}
            </footer>
            <ToastContainer position="top-end" className="p-3 text-white" style={{ zIndex: 1 }} >
                <Toast show={state?.message?.show} bg={state?.message?.type} autohide={true} delay={2000}>
                    <Toast.Body>
                        {state?.message?.note}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    )
}